var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDominicanRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C31.0454 40 39.9998 31.0457 39.9998 20C39.9998 8.9543 31.0454 0 19.9998 0C8.95406 0 -0.000244141 8.9543 -0.000244141 20C-0.000244141 31.0457 8.95406 40 19.9998 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.688843 25.2174C2.53556 32.0692 7.93064 37.4644 14.7825 39.3111V25.2174H0.688843Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7824 0.688965C7.93064 2.53561 2.53548 7.93076 0.688843 14.7826H14.7825V0.688965H14.7824Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.311 14.7826C37.4644 7.93076 32.0692 2.53561 25.2174 0.688965V14.7826H39.311V14.7826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2174 39.311C32.0692 37.4643 37.4644 32.0692 39.3111 25.2173H25.2174V39.311Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 20C25.2173 22.8816 22.8815 25.2174 19.9999 25.2174C17.1184 25.2174 14.7825 22.8816 14.7825 20C14.7825 17.1185 19.9999 14.7826 19.9999 14.7826C19.9999 14.7826 25.2173 17.1185 25.2173 20Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7825 20C14.7825 17.1185 17.1184 14.7826 19.9999 14.7826C22.8815 14.7826 25.2173 17.1185 25.2173 20",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0652 17.3914V20.6522C17.0652 22.2731 18.3791 23.587 20 23.587C21.6208 23.587 22.9347 22.2731 22.9347 20.6522V17.3914H17.0652Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominicanRepublic);
export default __webpack_public_path__ + "static/media/dominican_republic.547e6d7eb1e5fcd7e46c03b858b66d40.svg";
export { ForwardRef as ReactComponent };